import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

/**
 * Reviews carousel (uses embla). Split into its own chunk and rendered lazily so
 * the heavy carousel library stays out of the critical main bundle.
 */
const HomeReviews = ({ reviews = [] }) => (
  <Carousel opts={{ loop: true }} className="max-w-4xl mx-auto" data-testid="reviews-carousel">
    <CarouselContent>
      {reviews.map((r) => (
        <CarouselItem key={r.id} className="md:basis-1/2">
          <div className="glass-dark rounded-[18px] p-6 h-full">
            <Quote className="h-7 w-7 text-[var(--lux-champagne)]" />
            <p className="text-white/90 mt-3 leading-relaxed">{r.text}</p>
            <div className="flex items-center gap-3 mt-5">
              <Avatar><AvatarImage src={r.author_avatar} /><AvatarFallback>{r.author_name?.[0]}</AvatarFallback></Avatar>
              <div>
                <div className="font-medium text-white">{r.author_name}</div>
                <div className="flex">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-[var(--lux-champagne)] text-[var(--lux-champagne)]" />)}</div>
              </div>
            </div>
          </div>
        </CarouselItem>
      ))}
    </CarouselContent>
    <CarouselPrevious className="text-[var(--lux-ink)]" />
    <CarouselNext className="text-[var(--lux-ink)]" />
  </Carousel>
);

export default HomeReviews;
